import styles from "./UpgradeBanner.module.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import labels from "../../../config/labels";
import config from "../../../config/index";
import { componentResize } from "../../../utils/helperServices";
import * as Analytics from "../../../services/analyticsUtag";
import { displayHideUpgradeTopbannerModal, displayHideUpgradeModal, updateJourneyStatus, generateOneTimePin } from "../../../Redux/actions/upgradeAction";
import { useRouter } from "../../atoms/DependencyHelper";
import { maskMsisdn, upgradeStages } from "../../../services/upgradeService";
import { useState, useEffect } from "react";
import {
    setContractMode
} from "../../../Redux/actions/dealBuilderAction";

const UpgradeBanner = ({ upgrade, displayHideUpgradeTopbannerModal, displayHideUpgradeModal, updateJourneyStatus, generateOneTimePin, setContractMode }) => {
    const env = config.env;
    const isMobile = componentResize();
    const imagePrefix = config.envConfigs[env].imagePrefix;
    const imgUrl = `${imagePrefix}/assets/images/upgrade-info.svg`;
    const imgSize = 30;
    const [idleCounter, setIdleCounter] = useState(0);
    let pageName = "";

    const onSeeDetails = () => {
        displayHideUpgradeTopbannerModal(true);
        pageName = Analytics.getPageName();
        const cutomerType = (upgrade?.selectedUpgradeResponse?.business) ? "EBU" : (upgrade?.selectedUpgradeResponse?.c3dCustomer) ? "C3D" : "Legacy";
        Analytics.link({
            link_type: "o",
            link_name: `${pageName}: ${labels.lbl_top_banner.lbl_btn.lbl_see_detail}`
        })
        Analytics.view({
            page_event: "view",
            page_name: `${pageName}: see details`,
            page_master_tab: "personal",
            upgrade_eligibility_status: `${upgrade?.selectedUpgradeResponse?.upgradeEligible ? upgrade?.selectedUpgradeResponse?.upgradeEligible : false}`,
            upgrade_eligible_date: upgrade?.selectedUpgradeResponse?.upgradeDate,
            upgrade_customer_type: cutomerType,
            ...Analytics.getUtagData(["visitor_login",
                "visitor_customer_id",
                "visitor_msisdn_hash",
                "visitor_subscription_type",
                "page_site_section_lvl_1",
                "page_site_section_lvl_2",
                "page_site_section_lvl_3",
                "page_site_section_lvl_4"])

        })
        Analytics.setPageName(pageName);
    }

    const isEligible = () => {
        return upgrade?.upgradeCheckDone && upgrade?.selectedUpgradeResponse?.upgradeEligible && upgrade?.topBannerVisible;
    }

    const fetchOTP = async () => {
        generateOneTimePin(upgrade?.selectedUpgradeResponse?.msisdn);
    };

    const checkIdleTimeSpan = () => {
        var IDLE_TIMEOUT = 1200;
        var secondCounter = idleCounter;
        if (secondCounter == IDLE_TIMEOUT) {
            displayHideUpgradeModal(true);
            updateJourneyStatus(null, upgradeStages.OTP_ENRTY);
            fetchOTP();
        } else if (secondCounter > IDLE_TIMEOUT) {
            setIdleCounter(0)
        }
    }


    const checkIdleTime = (idleCounter) => {
        document.addEventListener('click', function (e) {
            setIdleCounter(0);
        }, false)
        document.onkeypress = function () {
            setIdleCounter(0);
        }
        if (isEligible()) {
            checkIdleTimeSpan(idleCounter)
        }
    }

    useEffect(() => {
        if (isEligible()) {
            setContractMode('upgrade');
        }
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            setIdleCounter(idleCounter + 1);
            checkIdleTime(idleCounter)
        }, 1000);

        return () => clearInterval(interval);
    }, [idleCounter]);

    return <div className={isEligible() ? 'upgradeVisible' : ''}>
        {isEligible() &&
            <div className={styles.banner}>
                <div className={`container ${styles.banner}`} id="seeUpgradeDetails">
                    <div className={styles.wrapper}>
                        <div className={styles.message}>
                            {!isMobile && (<span className={styles.text}>{labels.product_affordability.lbl_upgrade_banner} {upgrade?.selectedUpgradeResponse?.msisdn}</span>)}
                            {isMobile && (<span className={styles.text}>{labels.product_affordability.lbl_busy_mobile} {upgrade?.selectedUpgradeResponse?.msisdn}</span>)}
                        </div>
                        <button className={styles.button} onClick={onSeeDetails}>Cancel</button>
                    </div>
                </div>
            </div>
        }
    </div>
}

UpgradeBanner.propTypes = {
    upgrade: PropTypes.object,
    displayHideUpgradeTopbannerModal: PropTypes.func,
    setContractMode: PropTypes.func
};

const mapStateToProps = (state) => ({
    upgrade: state.upgrade,
});

export default connect(mapStateToProps, { displayHideUpgradeTopbannerModal, displayHideUpgradeModal, updateJourneyStatus, generateOneTimePin, setContractMode })(UpgradeBanner);
